const PaymentFail = () => {
  return <div className="text-danger">Something Went Wrong!</div>;
};

export default PaymentFail;
